export const beanPath = (beanId: Number) => `/bean/${beanId}`;
